import { addPopup, addNotification } from "../../supplementary_components/store";
import { API_ROOT, sendRequest } from "../../supplementary_components/requests";
import { CustomAddForm } from "../../general_components/forms/CustomAddForm";

export function byDriverStatementGeneration(weekStartDate, setOpenStatementsByDrivers, setStatementsList){
    const InputFormData = {columns: [
        {
            label: "Driver",
            name: 'driver',
            mandatory: true,
            suggestionsEnabled: true,
            dataValueRequired : true,
            autoComplete:"off",
            suggestionsLink: API_ROOT+'drivers/namecontaines?name=',
            displayValueGenerator: (val)=>{return `${val["firstName"]} ${val["lastName"]}`;},
        },
        
    ]}
    addPopup({
        content:CustomAddForm,
        popupData:{
            action:(event, postResultAction)=>{
                event.preventDefault();
                const driverData = JSON.parse(event.target['driver'].getAttribute('data-value'));
                sendRequest("POST", API_ROOT+"statements/regenerateStatementByDriver?driverId="+driverData.id+"&weekStartDate="+weekStartDate, null, (statement)=>{
                    
                    postResultAction(true);
                    if(statement){
                        setOpenStatementsByDrivers({defaultStatementsArray: [statement],
                            driverIds: [driverData.id]});
                        
                        setStatementsList(prev => {
                            const exists = prev.some(item => item.id === statement.id);
                            return exists ? prev.map(item =>
                                item.id === statement.id ? { ...item, status: 'inReview' } : item
                            ) : [...prev, statement];
                        });
                    }
                }, ()=>{
                    addNotification({message:`Something went wrong`, type:'alert'});
                    postResultAction(false);
                })
            },
            name:"Confirm",
            formTitle:`Generate Statement By Driver`,
            submitTitle:`Generate`,
            method:"POST",
            columns: InputFormData['columns']
        }, 
        EZCloseAllowed:true
    })
}